import { Component, ReactNode } from "react";

type Props = { children: ReactNode };
type State = { failed: boolean };

const RELOAD_KEY = "reload_at";

const shouldReload = () => {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
  if (Date.now() - last < 3000) return false;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  return true;
};

export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    console.error(error);
    if (shouldReload()) window.location.reload();
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}
